<template>
    <div class="send-success-body" v-if="show">
        <div class="send-success-box" @click.stop>
            <div class="send-success-title">
                送信成功
            </div>
            <div class="send-success-msg">
                お申込みを受け付けました。ご登録時に使用されたEメールアドレス宛てに確認メールをお送りいたします。
            </div>
            <div class="close-box">
                <div @click="toHome()">確認</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {

        }
    },
    props: {
        isShow: {
            default: () => {
                return false
            }
        }
    },
    computed: {
        show: {
            get () {
                return this.isShow
            },
            set (val) {
                this.$emit('update:isShow', val)
            }
        }
    },
    methods: {
        toHome () {
            this.show = false
            this.$router.push('/')
        }
    }
}
</script>
<style scoped>
.send-success-body {
    position: fixed;
    top:0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.5);
}
.send-success-box {
    width: 270px;
    height:247px;
    border-radius: 6px;
    padding: 10px 20px;
    box-sizing: border-box;
    text-align: center;
    background-color: #fff;
    position: absolute;
    left: 0;
    top: 0;
    right:0;
    bottom: 0;
    margin: auto
}
.send-success-title {
    padding-top: 20px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #000000;
    line-height: 30px;
    margin-bottom: 10px;
}
.send-success-msg {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 24px;
    text-align: left;
    margin-bottom: 20px
}
.close-box {
    width: 100px;
    height: 40px;
    margin: 0 auto;
    background: #FDB819;
    border-radius: 5px;
    text-align: center;
    line-height:  40px;
    text-align: center;
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #101010;
}
</style>